export class IdentityModel {
      TOKEN?: '';
      v_estado?: '';
      v_ultima_contrasena?: '';
      v_documento?: '';
      v_apellido_2?: '';
      v_apellido_1?: '';
      v_tipo_documento?: '';
      v_nombre_1?: '';
      v_nombre_2?: '';
      v_sucursal?: '';
      v_pais?: '';
      pais?: any;
      v_usuario?: any;
 }
